import { createRouter, type RouterHistory } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { routeTree } from '../routeTree.gen'
import { isBrowser } from './env'

export interface RouterContext {
  queryClient: QueryClient
}

export interface CreateAppRouterOptions {
  queryClient: QueryClient
  history?: RouterHistory
}

export function createAppRouter({ queryClient, history }: CreateAppRouterOptions) {
  const router = createRouter({
    routeTree,
    context: { queryClient },
    history,
    defaultPreload: 'intent',
    scrollRestoration: true,
  })

  // GA page-views are fired from the content-layout <Analytics /> component,
  // which only mounts on public content pages — so app routes are never tracked.
  if (isBrowser && router) {
    // intentionally empty: kept as the hook point for future global router side-effects
  }

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}
